import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { FeedbackService } from './service/feedback.service';
import { HttpParams } from '@angular/common/http';
import { AlertService } from '@foh/shared/services/alert.service';

@Component({
  selector: 'app-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.scss']
})
export class FeedbackComponent implements OnInit {
  feedbackForm!: any;
  answers: any[] = [];
  referenceCode: string = '';
  formStyle: any = {};
  en: boolean = true;
  textError: string | null = "";
  submitLoading: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private feedbackService: FeedbackService,
    private alertService: AlertService
  ) { }

  ngOnInit() {

    this.referenceCode = this.route.snapshot.queryParams['reference_code'];
    this.getFullMenu(this.referenceCode);
  }

  getQuestionOptions(options: string) {
    try {
      return JSON.parse(options);
    } catch {
      return [];
    }
  }

  answersValid() {
    return this.feedbackForm.questions.every((q: any, i: number) => {
      if (!q.required) return true;
      return this.answers[i].value !== null && this.answers[i].value !== '';
    });
  }

  getFullMenu(reference_code: any) {
    let params = new HttpParams();
    params = params.set("reference_code", reference_code);
    this.feedbackService.getFullMenu(params).subscribe({
      next: (payload) => {
        this.feedbackForm = payload.data;

    
        // this.formStyle = {
        //   'background-color': this.feedbackForm.background_color,
        //   'color': this.feedbackForm.primary_color,
        //   '--primary-color': this.feedbackForm.primary_color,
        //   '--secondary-color': this.feedbackForm.secondary_color
        // };
    
        this.answers = this.feedbackForm.questions.map((question: any) => ({
          question_id: question.id,
          value: null,
          touched:false,
        }));
      }, 

      error: (err) => { // Use arrow function
        // Extract error message properly for Angular HttpClient errors
        this.textError = err.error.message;
        // Optionally show alert using AlertService
       // this.alertService.error(err.error.status , err.error.message);
      },
    });
  }

  submitForm() {

    const formData = new FormData();
    this.submitLoading = true;
    this.answers.forEach((answer, index) => {
      formData.append(`answers[${index}][question_id]`, answer.question_id.toString());
      if (answer.value !== null) {
        formData.append(`answers[${index}][value]`, answer.value.toString());
      }
    });

    formData.append('reference_code', this.referenceCode);

    this.feedbackService.postAnswers(formData).subscribe({
      next: (payload) => {
        this.submitLoading = false;
        this.alertService.success('Success', 'Your feedback has been submitted successfully!');
        //reload the page
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      },
      error: (err) => {
        this.submitLoading = false;
      }
    });

    // formData.forEach((val, key) => {
    //   console.log(val, key);
    // });
  }
  toggleLanguage() {
    this.en = !this.en;
    document.documentElement.setAttribute('dir', this.en ? 'ltr' : 'rtl');
    // Optionally set the lang attribute for accessibility
    document.documentElement.setAttribute('lang', this.en ? 'en' : 'ar');
  }

  getFormName(): string {
    if (!this.feedbackForm) return ''; // Add safety check
    return this.en ? this.feedbackForm.name : this.feedbackForm.name_ar;
  }
  
  getFormDescription(): string {
    if (!this.feedbackForm) return ''; // Add safety check
    return this.en ? this.feedbackForm.description : this.feedbackForm.description_ar;
  }

  // Added helper method to get question text based on current language
  getQuestionText(question: any): string {
    return this.en ? question.question : question.question_ar;
  }
  getQuestionOptionsTranslated(question: any): any[] {
    try {
      const options = this.en ? question.options : question.options_ar; 
      return options ? JSON.parse(options) : [];
    } catch {
      return [];
    }
  }
}











//   this.feedbackForm = {
  //     "id": 1,
  //     "mcompany_id": 24,
  //     "name": "Customer Satisfaction Survey",
  //     "name_ar": "استطلاع رضا العملاء",
  //     "description": "A survey to gather customer feedback",
  //     "description_ar": "استطلاع لجمع تعليقات العملاء",
  //     "active": true,
  //     "public": false,
  //     "anonymous": false,
  //     "background_color": "#FFFFFF",
  //     "primary_color": "#007BFF",
  //     "secondary_color": "#6C757D",
  //     "accent_color": "#28A745",
  //     "logo": "logo_1742466795_OJ1j0g1AXl.jpg",
  //     "alias": "customer-survey",
  //     "created_at": "2025-03-17T13:56:07.000000Z",
  //     "updated_at": "2025-03-20T10:33:16.000000Z",
  //     "questions": [
  //         {
  //             "id": 6,
  //             "feed_back_form_id": 1,
  //             "question": "Please provide any additional comments",
  //             "question_ar": "يرجى تقديم أي تعليقات إضافية",
  //             "type": "text",
  //             "options": null,
  //             "options_ar": null,
  //             "required": false,
  //             "order": 4,
  //             "created_at": "2025-03-17T14:14:38.000000Z",
  //             "updated_at": "2025-03-17T14:14:38.000000Z"
  //         },
  //         {
  //             "id": 7,
  //             "feed_back_form_id": 1,
  //             "question": "Please rate our service from 1 to 5",
  //             "question_ar": "يرجى تقييم خدمتنا من 1 إلى 5",
  //             "type": "integer",
  //             "options": null,
  //             "options_ar": null,
  //             "required": true,
  //             "order": 2,
  //             "created_at": "2025-03-17T14:14:46.000000Z",
  //             "updated_at": "2025-03-17T14:14:46.000000Z"
  //         }
  //     ]
  // };

  // this.formStyle = {
  //   'background-color': this.feedbackForm.background_color,
  //   'color': this.feedbackForm.primary_color,
  //   '--primary-color': this.feedbackForm.primary_color,
  //   '--secondary-color': this.feedbackForm.secondary_color
  // };